import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import IdleTimer from 'react-idle-timer';
import promotion from '../promotionConfig';
import isApp from '../utils/isApp';

const IdleTimeout = ({ loading, user, config, actions }) => {
    const idleTimerRef = useRef(null);
    const [auto_terminate, setAutoTerminate] = useState(config.config.auto_terminate_seconds);

    const [hasMounted, setHasMounted] = useState(false);

    useEffect(() => {
        setHasMounted(true);
        if (config.config) {
            setAutoTerminate(config.config.auto_terminate_seconds);
        }
    }, [config]);

    const timeout = auto_terminate !== '' ? parseInt(auto_terminate, 10) * 1000 : auto_terminate;

    let myLocation = typeof window !== 'undefined' ? window.location.protocol + '//' + window.location.host + window.location.pathname : '';

    // remove any trailing slashes
    myLocation = myLocation.replace(/\/$/, '');

    if (!hasMounted || loading.actions['getPlayerData'] || loading.actions['getConfig']) {
        return null;
    } else {
        const myHost = window.location.protocol + '//' + window.location.host;
        const logoutDestination = promotion.getLogoutDestination(myHost, config.config.logout_host_uri);
        const eventsToWatch = [
            'mousemove',
            'keydown',
            'wheel',
            'DOMMouseScroll',
            'mousewheel',
            'mousedown',
            'touchstart',
            'touchmove',
            'MSPointerDown',
            'MSPointerMove',
        ];

        return user.loggedIn && timeout ? (
            <>
                <IdleTimer
                    ref={idleTimerRef}
                    onIdle={async () => {
                        // user has been idle for auto_terminate_seconds
                        //? for debug: console.log('User timed out: ' + timeout);
                        window.location.search = '';
                        if (isApp()) {
                            //? for debug: console.log('Sending postMessage to refresh token');
                            window.parent.postMessage(
                                {
                                    message: 'openLogin',
                                    error: 'token_expired',
                                    redirect: myLocation,
                                },
                                '*'
                            );
                        } else {
                            await actions.userActions.logout();
                            window.location.href = logoutDestination;
                        }
                    }}
                    timeout={timeout}
                    events={eventsToWatch}
                />
            </>
        ) : null;
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(IdleTimeout);
